import { camelize } from '@ridi/object-case-converter';
import { initializeRidi } from 'app/common/ridi.store/ridi.actions';
import { RidiState } from 'app/common/ridi.store/ridi.reducer';
import { commonStore } from 'src/app/common/ridi.store/ridi.commonStore';

window.addEventListener('ridiStoreLoad', (event: CustomEvent) => {
  const store = commonStore.getStore();
  const ridiDTO = camelize<RidiState>(event.detail);
  store.dispatch(initializeRidi(ridiDTO));
});

export * from 'src/app/common/ridi.store/ridi.commonStore';
export * from 'src/app/common/ridi.store/ridi.reducer';
export * from 'src/app/common/ridi.store/ridi.actions';



// WEBPACK FOOTER //
// ./common/ridi.store/index.ts